import type { OpportunityStatus } from '@/core/opportunity/opportunity-status';

export const OPPORTUNITY_LEFT_PENDING_STATUS = 'OPPORTUNITY_LEFT_PENDING_STATUS';

export interface NotificationMessage {
  readonly type: typeof OPPORTUNITY_LEFT_PENDING_STATUS;
  readonly opportunityId: string;
  readonly legalName: string;
  readonly status: OpportunityStatus;
}
